export default (riskQuestionnaireType)=>[{
    "id": 1,
    "title": "",
    "active": true,
    "component": "Welcome"
},
{
    "id": 2,
    "title": "Risk Tolerance",
    "active": false,
    "component": riskQuestionnaireType
},
{
    "id": 3,
    "title": "Experience",
    "active": false,
    "component": "EXP10"
},
{
    "id": 4,
    "title": "Thank You",
    "active": false,
    "component": "thankyou"
}
]